module.exports = __webpack_public_path__ + "static/img/pinpai-30.568fe255.png";